/**
 * Collection category nav — acknowledge a subcollection click immediately.
 *
 * Moving between subcollections is a full cross-document navigation, and the
 * collection document is large (see docs/performance.md). Until it arrives the
 * outgoing page stays fully painted, so a click that *has* already started
 * navigating looks like it did nothing — shoppers then click a second time.
 *
 * This only adds the missing affordance; the browser is already navigating and
 * nothing here alters, delays, or prevents that.
 */
(function () {
  const LINK_SELECTOR = '.collection-category-nav__link';
  const PENDING_CLASS = 'collection-category-nav__link--pending';

  /**
   * Modified and non-primary clicks either open a new context or do nothing at
   * all, so the current page would keep a pending link forever.
   * @param {MouseEvent} event
   * @returns {boolean}
   */
  function opensInThisTab(event) {
    return (
      !event.defaultPrevented &&
      event.button === 0 &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey
    );
  }

  function clearPending() {
    for (const link of document.querySelectorAll('.' + PENDING_CLASS)) {
      link.classList.remove(PENDING_CLASS);
      link.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    if (!opensInThisTab(event)) return;

    const target = event.target;
    const link = target instanceof Element ? target.closest(LINK_SELECTOR) : null;
    if (!link || !(link instanceof HTMLAnchorElement) || link.target === '_blank') return;

    // One pending link at a time, so a second click re-points the indicator.
    clearPending();
    link.classList.add(PENDING_CLASS);
    link.setAttribute('aria-busy', 'true');
  });

  // A restore from the back/forward cache replays the page mid-navigation,
  // pending link and all; the navigation it referred to is long finished.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) clearPending();
  });
})();
